import { render } from "./AddJourneyModal.vue?vue&type=template&id=c9674696"
import script from "./AddJourneyModal.vue?vue&type=script&lang=js"
export * from "./AddJourneyModal.vue?vue&type=script&lang=js"

import exportComponent from "/home/airsxm/domains/airsxm.ridders.dev/public_laravel/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__